// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2r0HK","actions":"GroupTable_actions__3sgu_","deleteModalFooter":"GroupTable_deleteModalFooter__p8wtC"};